import querystring from 'querystring'
import config from 'config'

const getCtaUrl = (utms, theme, role, omitUtmParams) => {
  const params = {
      utm_source: utms.utm_source,
      utm_medium: utms.utm_medium,
      utm_campaign: utms.utm_campaign,
      utm_content: utms.utm_content,
      credclid: utms.credclid,
      renderId: utms.renderId,
    },
    dotDashThemes = ['investopedia1', 'thebalance1'],
    urlParams = omitUtmParams ? {} : params,
    ctaUrl = dotDashThemes.includes(theme)
      ? `${config.credibleRoot}/student-loans?${querystring.encode(urlParams)}`
      : `${config.credibleRoot}/private-student-loans/get-started?${querystring.encode({ ...urlParams, role })}`

  return ctaUrl
}

export { getCtaUrl }
